<template>
    <div class="provinces">
        <div class="slider">
            <div class="item">
                <div class="col-12 float-left"
                     style="margin-top:150px;margin-bottom:30px;">
                    <h1>استان مورد نظر خود را انتخاب نمایید</h1>
                </div>
            </div>
        </div>
        <div class="container p-0">
            <div class="content">
                <div v-for="(province,provinceIndex) in provinces" :key="provinceIndex" class="col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10">
                    <router-link class="item" :to="{ name: 'shops', params: { provinceId: province.provinceId,shopCategoryId:0 , name :province.name  } }">
                        <div class="details">
                            <label class="name">{{ province.name }}</label>
                        </div>
                        <div class="inner">
                            <div class="img"
                                 v-bind:style="{'background-image':'url(' + rootImagePath + province.imagePath + ')'}"></div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            provinces: {
                type: Array
            }
        },

        data()
        {
            return {
                loading: true
            };
        }
    };
</script>
<style>
    .provinces {
        width: 100%;
        float: right;
        text-align: center;
        position: relative;
        background: #EAEDED;
    }


        .provinces .content {
            width: 100%;
            float: right;
            padding-top:30px;
        }

            .provinces .content .item {
                transition: all 0.5s;
                width: 100%;
                height: 370px;
                display: inline-block;
                padding: 10px;
                background: #fff;
            }

                .provinces .content .item .inner {
                    width: 100%;
                    height: 300px;
                    float: right;
                    position: relative;
                }

                .provinces .content .item .img {
                    background-position: center center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    width: 100%;
                    height: 300px;
                }

                .provinces .content .item .details {
                    width: 100%;
                    color: #000;
                    text-align: right;
                    font-weight: bold;
                    font-size: 16px;
                }


    @media (max-width: 1024px) {
            .provinces .content .item {
                height: 230px;
                padding: 5px;
            }

                .provinces .content .item .inner,
                .provinces .content .item .img {
                    height: 190px;
                }

                .provinces .content .item .details {
                    font-size: 14px;
                }
    }


    .slider,
    .slider .item {
        width: 100%;
        float: left;
        height: 250px;
    }

    .slider {
        padding: 0 !important;
        margin-bottom: 0;
    }

        .slider .item {
            background: #292929;
        }

        .slider h1 {
            position: relative;
            text-align: center;
            color: #fff;
            font-size: 25px;
        }
</style>
